// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___2Bwh","listOfArticles":"styles_listOfArticles__LN4Jj","authorContainer":"styles_authorContainer__kpV03"};